import { Formik, Field, Form, ErrorMessage } from 'formik';
import React from 'react';
import useRegister from 'hooks/useRegister'
import '../RegisterForm.css'

export default function RegisterArtist() {
    const { initialValues, validateFields, regArtist } = useRegister()

    return (
        <>
            <div className="form-container">
                
                <Formik
                    initialValues={initialValues}
                    validate={validateFields}
                    onSubmit={(values, { setFieldError }) => {
                        const body = {
                            username: values.username,
                            password: values.password,
                            alias: values.alias,
                            role: 1,
                            profile_type: false,
                            conditions: values.conditions.length === 2 ? true : false
                        }

                        return regArtist(body)
                            .catch(() => {
                                setFieldError('generic', 'Revisa los campos e intentalo de nuevo')
                            })
                    }}
                >

                    {
                        ({ errors, isSubmitting, values }) => (
                            <Form className="form" >
                                <div className='campos-field'>
                                    <div className='campo-field-usernameR'>
                                <label htmlFor="username" className="label-text">
                                    Usuario:
                                </label>
                                <Field type="text" className="input-field" placeholder='Username' name="username" value={values.username} />
                                <ErrorMessage name="username" component="small" className="form-errors" />
                                </div>


                                <div className='campo-field-alias'>
                                <label htmlFor="alias" className="label-text">
                                    Alias:
                                </label>
                                <Field type="text" className="input-field" placeholder='Alias' name="alias" value={values.alias} />
                                <ErrorMessage name="alias" component="small" className="form-errors" />
                                </div>

                                <div className='campo-field-password'>
                                <label htmlFor="password" className="label-text"> 
                                    Contraseña:
                                </label>
                                <Field type="password" className="input-field" placeholder='Password' name="password" value={values.password} />
                                <ErrorMessage name="password" component="small" className="form-errors" />
                                 </div>
                                <div id="checkbox-group-form">Condiciones</div>
                                <div role="group" className="form-checkbox" aria-labelledby="checkbox-group-form">
                                    <label>
                                        <Field type="checkbox" name="conditions" value="contentAccept" />
                                        No subiré contenido inapropiado, confirmo que mis intenciones son éticas y no fraudulentas, no haré mal uso de la plataforma, y tengo un sueldo mensual por debajo del mínimo profesional
                                    </label>
                                    <label>
                                        <Field type="checkbox" name="conditions" value="passwordAccept" />
                                        Si se pierde la contraseña se perderá la cuenta
                                    </label>
                                    <ErrorMessage name="conditions" component="small" className="form-errors" />
                                </div>
                                

                                <button type="submit" className="submit-btn" disabled={isSubmitting}>Registrar</button>
                                <ErrorMessage name="generic" component="small" className="form-errors" />
                                </div>
                            </Form>
                        )
                    }

                </Formik>
            </div>
        </>
    )

}